import { render, staticRenderFns } from "./teachingandknowledge.vue?vue&type=template&id=d3f19cd2&"
import script from "./teachingandknowledge.vue?vue&type=script&lang=js&"
export * from "./teachingandknowledge.vue?vue&type=script&lang=js&"
import style0 from "./teachingandknowledge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports